<template>
  <div class="statusWarning">
    <MyTable class="animated fadeInUp" :tableData="tableData" :configTable="configTable" />
    <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"> </el-pagination>
  </div>
</template>

<script>
import { getDeviceStatusApi } from '@/request/api.js'
import { mapState } from 'vuex'
export default {
  components: {
    MyTable: () => import('@/components/MyTable.vue')
  },
  data() {
    return {
      tableData: [],
      total: 0,
      current_page: 1,
      configTable: [
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'code',
          label: 'code',
          width: ''
        },
        {
          prop: 'address',
          label: '位置',
          width: ''
        },
        {
          prop: 'online',
          label: '状态',
          width: '200'
        },

        {
          prop: 'created_time',
          label: '时间',
          width: '240'
        }
      ]
    }
  },
  created() {
    this.getDeviceStatus()
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID
    })
  },
  methods: {
    handleCurrentChange(val) {
      this.current_page = val
      this.getDeviceStatus()
    },
    async getDeviceStatus() {
      const { code, results } = await getDeviceStatusApi({
        pn: this.current_page
      })
      if (code != 0) return
      this.current_page = results.pn
      this.tableData = results.data
      this.tableData = this.tableData.map((item) => {
        item.online = item.online === 1 ? '在线' : '离线'
        return item
      })
      this.total = results.count
    }
  }
}
</script>

<style lang="less" scoped>
.statusWarning {
  width: 100%;
  min-height: 100vh;
  background-color: #071a2c;
  padding: 62px 48px 0;
}
</style>
